/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ExtensibleNode } from '../ExtensibleNode';
import { ImplicitOAuthFlow } from './ImplicitOAuthFlow';
import { PasswordOAuthFlow } from './PasswordOAuthFlow';
import { ClientCredentialsOAuthFlow } from './ClientCredentialsOAuthFlow';
import { AuthorizationCodeOAuthFlow } from './AuthorizationCodeOAuthFlow';

/**
 * Constructor.
 * @class
 * @extends ExtensibleNode
 * @author eric.wittmann@gmail.com
 */
export abstract class OAuthFlows extends ExtensibleNode {
    public implicit : ImplicitOAuthFlow;

    public password : PasswordOAuthFlow;

    public clientCredentials : ClientCredentialsOAuthFlow;

    public authorizationCode : AuthorizationCodeOAuthFlow;

    public constructor() {
        super();
        if(this.implicit===undefined) this.implicit = null;
        if(this.password===undefined) this.password = null;
        if(this.clientCredentials===undefined) this.clientCredentials = null;
        if(this.authorizationCode===undefined) this.authorizationCode = null;
    }

    /**
     * Creates an OAuth Flow object.
     * @return {ImplicitOAuthFlow}
     */
    public abstract createImplicitOAuthFlow() : ImplicitOAuthFlow;

    /**
     * Creates an OAuth Flow object.
     * @return {PasswordOAuthFlow}
     */
    public abstract createPasswordOAuthFlow() : PasswordOAuthFlow;

    /**
     * Creates an OAuth Flow object.
     * @return {ClientCredentialsOAuthFlow}
     */
    public abstract createClientCredentialsOAuthFlow() : ClientCredentialsOAuthFlow;

    /**
     * Creates an OAuth Flow object.
     * @return {AuthorizationCodeOAuthFlow}
     */
    public abstract createAuthorizationCodeOAuthFlow() : AuthorizationCodeOAuthFlow;
}
OAuthFlows["__class"] = "io.apicurio.datamodels.core.models.common.OAuthFlows";
OAuthFlows["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




